import { render, staticRenderFns } from "./NormalRadio.vue?vue&type=template&id=2980cd02&scoped=true"
import script from "./NormalRadio.vue?vue&type=script&lang=js"
export * from "./NormalRadio.vue?vue&type=script&lang=js"
import style0 from "./NormalRadio.vue?vue&type=style&index=0&id=2980cd02&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2980cd02",
  null
  
)

export default component.exports